import Vue from 'vue';
import Vuex from 'vuex';
import orderDetail from './modules/order/orderDetail';
import orderConfirm from './modules/order/orderConfirm';
import orderList from './modules/order/orderList';
import address from './modules/address/index';
import logistics from './modules/logistics/index';
import common from './modules/common/index';
import shopCart from './modules/shop';
import activity from './modules/activity';
// import createLogger from "../../../src/plugins/logger";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    common,
    orderDetail,
    orderConfirm,
    orderList,
    address,
    logistics,
    shopCart,
    activity,
  },
  strict: debug,
  // plugins: debug ? [createLogger()] : []
});
